import { post, del, get } from './requests'

export const cloneFeed = (entity, payload) => post([entity], {}, payload)
export const createFeed = (entity, payload) => post([entity], {}, payload)
export const deleteFeed = (entity, payload) => del([entity], {}, payload)
export const schema = (entity) => get([entity, 'schema'])
